'use strict';

import axios from 'axios';

export default {
    create: function (data) {
        let method = 'post';
        let url = window.Routes.user.create;
        if (data.uid) {
            url = url + data.uid;
        }
        return axios({
            method: method,
            url: url,
            data: data
        }).then((response) => {
            return Promise.resolve(response.data);
        }).catch((error) => {
            return Promise.reject(error.response.data);
        });
    },
    me: function () {
        return axios({
            method: 'post',
            url: window.Routes.user.show,
        }).then((response) => {
            return Promise.resolve(response.data);
        }).catch((error) => {
            return Promise.reject(error.response.data);
        });
    },
    update: function (data) {
        let method = 'post';
        let url = window.Routes.user.update;
        if (data.uid) {
            url = url + data.uid;
        }

        return axios({
            method: method,
            url: url,
            data: data
        }).then((response) => {
            return Promise.resolve(response.data);
        }).catch((error) => {
            return Promise.reject(error.response.data);
        });
    },
    save: function (data) {
        let method = 'post';
        let url = window.Routes.user.show;
        if (data.uid) {
            url = url + data.uid;
        }

        return axios({
            method: method,
            url: url,
            data: data
        }).then((response) => {
            return Promise.resolve(response.data);
        }).catch((error) => {
            return Promise.reject(error.response.data);
        });
    },
    checkEmail: function (email) {
        return axios({
            method: 'post',
            url: window.Routes.user.check_email,
            data: {
                email: email
            }
        }).then((response) => {
            return Promise.resolve(response.data);
        }).catch((error) => {
            return Promise.reject(error.response.data);
        });
    },
    checkCodeEtablissement: function (code) {
        return axios({
            method: 'post',
            url: window.Routes.user.check_code_etablissement,
            data: {
                code: code
            }
        }).then((response) => {
            return Promise.resolve(response.data);
        }).catch((error) => {
            return Promise.reject(error.response.data);
        });
    },
};
